import React from "react";
import type { FC } from "react";

import { Icon } from "../../../../Icon";

import type { TGlyphSizes } from "../../../../../assets/types/icons";

const TAB_LEFT_ICON_TEST_ID = "tab-left-icon-test-id";

export const TAB_LEFT_ICON_SIZE = "20";

export type TabLeftIconProps = Pick<
    Extract<TGlyphSizes, { size: typeof TAB_LEFT_ICON_SIZE }>,
    "icon"
>;

export const TabLeftIcon: FC<TabLeftIconProps> = ({ icon }) => {
    return (
        <Icon
            size={TAB_LEFT_ICON_SIZE}
            icon={icon}
            data-tsid={TAB_LEFT_ICON_TEST_ID}
        />
    );
};

TabLeftIcon.displayName = "Tab.LeftIcon";

export default TabLeftIcon;
